// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2lFJ9","label":"SetPasswdForm_label__3UsF0"};